import { SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { TreePalm } from "lucide-react";
import {
  Create,
  DateInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "../common";

const typeChoices = [
  { id: "public", name: "Public" },
  { id: "optional", name: "Optional" },
  { id: "company", name: "Company" },
];

const HolidayToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Save Holiday" />
  </div>
);

export const HolidayCreate = () => (
  <Create title="Create Holiday">
    <Card className="form-container">
      <div className="form-header-premium">
        <TreePalm className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Add New Holiday</h2>
      </div>
      <SimpleForm toolbar={<HolidayToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <DateInput source="date" />
          <SelectInput source="type" choices={typeChoices} defaultValue="public" />
        </div>
        <TextInput source="name" fullWidth className="mt-4" />
      </SimpleForm>
    </Card>
  </Create>
);

